export default function initHeaderScroll() {
  const header = document.querySelector('.header');

  // Function to handle scroll event
  function onScroll() {
    const scrollY = window.pageYOffset;

    // Calculate the translateY value based on the scroll position
    const translateYValue = Math.max(50 - scrollY, 0); // Start at 50px and reduce by scroll amount, capped at 0px

    header.style.transform = `translateY(${translateYValue}px)`;
  }

  // Attach scroll event listener
  window.addEventListener('scroll', onScroll);
}
